import {useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { HTTPURL,REQUEST_OPTIONS_NO_HEAD} from "../../constants/matcher";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import DataLoader from "../../Utils/DataLoader";
import { useForm } from "react-hook-form";
import { PDFReader } from 'reactjs-pdf-reader';
import { toast } from 'react-toastify';
import FileViewer from 'react-file-viewer';
import { Form} from 'semantic-ui-react';
import $ from 'jquery';
import  JSZip from 'jszip';

const LessonDetails = () =>
{
    const [files, setFiles] = useState({ preview: '', data: '' });
    const [courseName, setCourseName] = useStateWithCallbackLazy([]);
    const [image, setImage] = useStateWithCallbackLazy([]);
    const [pdf, setPdf] = useStateWithCallbackLazy([]);
    const [video, setVideo] = useStateWithCallbackLazy([]);
    const [less_assign, setless_assign] = useStateWithCallbackLazy([]);
    const [showResults, setShowResults] = useStateWithCallbackLazy(false);

    let allFiles = [];
    let imgIds = [];

    const {id} = useParams();

    const {
        register,
        setValue,
        handleSubmit,
        formState: { errors },
    } = useForm();

    // code for images changes
    const handleFileChange = (e) =>
    {
        for (let i = 0; i < e.target.files.length; i++) 
        {
            allFiles.push(e.target.files[i]);
        }
        setFiles({preview: '',data:allFiles});
    }

    useEffect(() => 
    {
        const token = JSON.parse(localStorage.getItem("user-token"));

        const lessonDetails = async() => 
        {
            try {
                return await fetch(HTTPURL+'user/lesson-details/'+id,{headers:{"Authorization" :`Bearer ${token}`} })
                .then((response) => response.json())
                .then((data) => 
                {
                    setCourseName(data.data[0], () => setShowResults(true));
                    setImage(data.data[1], () => setShowResults(true));
                    setPdf(data.data[2], () => setShowResults(true));
                    setVideo(data.data[3], () => setShowResults(true));
                    setless_assign(data.data[4], () => setShowResults(true));
                });
            } catch (error) {
                console.log(error);
            }
        }
        lessonDetails();
    },[]);

    // function for img
    const img_download = async() =>
    {
        // try {
        //     const requestOptions = {
        //         method: 'POST',
        //         headers: { 'Content-Type': 'application/json' },
        //         body: JSON.stringify({ imgIds: imgIds}),
        //         responseType: 'blob',
        //     };
        //     return await fetch(HTTPURL+'user/download-images',requestOptions)
        //     .then(data => data.json())
        //     .then(response => 
        //         {
        //             console.log('response',response.data);
        //         }
        //     );
        // } catch (error) {
        //     console.log(error);
        // }
    }
    const onSubmit = () => 
    {
        let formData = new FormData()
        files.data.forEach(file => {
            formData.append('files', file);
        });
        formData.append('assignment_id', id);
        componentDidMount(formData);
    }
    const componentDidMount = (requestData) =>
    {
        REQUEST_OPTIONS_NO_HEAD.method = 'POST';
        REQUEST_OPTIONS_NO_HEAD.body = requestData;
        fetch(HTTPURL+'user/upload-assignment', REQUEST_OPTIONS_NO_HEAD)
        .then(async response => 
        {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson && await response.json();
            if (!response.ok) 
            {
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            if(data.status === true)
            {
                setValue('upload_files','');
                $('#myModal').modal('show');
                toast.success(data.message);
            }else{
                toast.error(data.message)
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
    }

    return (
        <div className="container rounded bg-white mt-5 mb-5">
            <div className="row">
                <div className="col-md-1 border-right">
                </div>
                <div className="col-md-9 border-right">
                    {
                        showResults ? 
                        <div className="p-3 py-5">
                            <div className="text-end">
                                <button type="button" className="btn btn-primary sap-btn-dark" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                <i className="fa-solid fa-upload"></i> Upload Assignment
                                </button> 
                            </div>    
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="text-right"><i className="fa-solid fa-circle-info"></i> Lesson Details</h4>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="course name">Course Name: {courseName[0]?.course}</label>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="lesson name">Lesson Name: {courseName[0]?.lesson_name}</label>
                                </div>
                            </div>
                            <hr/>
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <h6 className="form-label" htmlFor="course content">Lesson Resources:</h6>
                                            <label className="form-label" htmlFor="image">Image:</label>
                                            <div className="d-flex flex-column align-items-center text-center prf-img-set">
                                                <div className="show-images">
                                                    {
                                                        image && image.map((img,index) => 
                                                        {  
                                                            imgIds.push(img.id);
                                                            return <img key={index} src={HTTPURL+'images/'+img.name} className="rounded-circle mt-5" height="100px" width="100px" /> 
                                                        })
                                                    }
                                                </div>
                                                <div className="download-data text-end">
                                                    <button className="btn btn-primary sap-btn-dark" onClick={img_download}> <i className="fa-solid fa-download"></i> download</button>
                                                </div>
                                            </div>
                                            <hr/>
                                            <label className="form-label" htmlFor="course name">Pdf:</label>
                                                <div className="d-flex flex-column align-items-center text-center prf-img-set">
                                                    <div className="show-images">
                                                        {
                                                            pdf && pdf.map((pdf,index) =>
                                                            {
                                                                return <PDFReader key={index} url={HTTPURL+'pdf/'+pdf.name} height="200" width="150" className="rounded-circle mt-5"/>
                                                            })
                                                        }
                                                    </div>
                                                    <div className="download-data text-end">
                                                        <button className="btn btn-primary sap-btn-dark"> <i className="fa-solid fa-download"></i> download</button>
                                                    </div>
                                                </div>     
                                            <hr/>
                                            <label className="form-label" htmlFor="Video">Video:</label>
                                            <div className="d-flex flex-column align-items-center text-center prf-img-set">
                                                <div className="show-images">
                                                    {
                                                        video && video.map((video,index) =>
                                                        {
                                                            return <iframe
                                                                    key={index}
                                                                    src={HTTPURL+'videos/'+video.name}
                                                                    width="480" 
                                                                    height="270"
                                                                />
                                                        })
                                                    }
                                                </div>
                                                <div className="download-data text-end">
                                                    <button className="btn btn-primary sap-btn-dark"><i className="fa-solid fa-download"></i> download</button>
                                                </div>
                                            </div>  
                                </div>
                            </div>
                            <hr/>
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <h6 className="form-label" htmlFor="course name">Lesson Assignment:</h6>
                                    <div className="d-flex flex-column align-items-center prf-img-set">
                                        <div className="show-images">
                                            {
                                                less_assign && less_assign.map((less_assign,index) =>
                                                {
                                                    return  <FileViewer 
                                                            key={index}
                                                            fileType="xlsx"
                                                            filePath={HTTPURL+'lessonAssignment/'+less_assign.name}
                                                        />
                                                })
                                            }
                                        </div>
                                        <div className="download-data text-end">
                                            <button className="btn btn-primary sap-btn-dark" ><i className="fa-solid fa-download"></i> download</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <DataLoader />
                    }
                </div>
            </div>
            {/* Modal */}
            <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Upload Your Assignment</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <Form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
                            <div className="modal-body">
                                <Form.Field>
                                    <label className="form-label" htmlFor="image"><i className="fa-solid fa-file"></i> Files:</label>
                                    <input
                                        placeholder='Upload Assignment'
                                        type="file"
                                        {...register("upload_files",{ required: true})}
                                        className="form-control form-control-lg"
                                        onChange={handleFileChange}
                                        multiple
                                    />
                                </Form.Field>
                                {errors.upload_files && errors.upload_files.type === "required" && <span className="validation-error">This is required</span>}
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary sap-btn-dark">Upload</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LessonDetails;